import { newSupportFormUrl, supportFormUrl } from '@/environment';
import { useAuth } from '@/services/auth';
import { useFlag } from '@/services/featureFlags';
import { useCreditQuery } from '@/state/credits/credits';

export const useGetSupportUrl = () => {
    const { user } = useAuth();
    const { data: credits } = useCreditQuery();
    const newSupportFormEnabled = useFlag('new_support_form', false);

    const fieldValues: Record<string, string | number | undefined> = newSupportFormEnabled
        ? { tf_anonymous_requester_email: user?.email, tf_22113892792721: `${user?.given_name} ${user?.family_name}` }
        : {
              email: user?.email,
              firstname: user?.given_name,
              lastname: user?.family_name,
              studio_user_id: user?.sub,
              studio_email: user?.email,
              studio_plan_name: user?.productName,
              studio_credits: credits?.remaining,
          };

    return (
        `${newSupportFormEnabled ? newSupportFormUrl : supportFormUrl}?` +
        Object.entries(fieldValues).reduce(
            (urlParams, [fieldName, fieldValue]) => (fieldValue ? `${urlParams}&${fieldName}=${fieldValue}` : urlParams),
            ''
        )
    );
};
